<template>
    <v-app id="app">
        <router-view/>
    </v-app>
</template>

<script>
    export default {
        name: "App",
        components: {},
        props: {},
        data() {
            return {};
        },
        computed: {},
    };
</script>

<style lang="scss" scoped>
    /*body {
        zoom: 75%;
    }*/
</style>